import { QRCode } from "antd";
import React from "react";

interface Props {
    value: string;
    onReady: (imageDataUrl: string | null) => void;
}

const MAX_FRAMES = 30;

// Draws a QR code off-screen with antd's QRCode and hands it back as a PNG data URL for react-pdf, which can't render
// the component itself. Reports null if it never draws.
const PdfQrCode: React.FC<Props> = ({ value, onReady }) => {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const onReadyRef = React.useRef(onReady);
    React.useEffect(() => {
        onReadyRef.current = onReady;
    });

    React.useEffect(() => {
        let frame = 0;
        let handle = 0;
        // antd paints the canvas after mounting, so wait a few frames for it.
        const check = () => {
            const canvas = containerRef.current?.querySelector("canvas");
            if (canvas && canvas.width > 0) {
                onReadyRef.current(canvas.toDataURL("image/png"));
            } else if (++frame < MAX_FRAMES) {
                handle = window.requestAnimationFrame(check);
            } else {
                onReadyRef.current(null);
            }
        };
        handle = window.requestAnimationFrame(check);
        return () => window.cancelAnimationFrame(handle);
    }, [value]);

    return (
        <div ref={containerRef} aria-hidden style={{ position: "fixed", left: -10000, top: 0 }}>
            <QRCode type="canvas" value={value} size={240} bordered={false} color="#000000" bgColor="#ffffff" />
        </div>
    );
};

export default PdfQrCode;
